import React, { useEffect, useState } from 'react';
import '../../commonComp/personalAndBank/personalandbank.scss';
import detailsEdit from '../../../../asset/images/ibaimages/detailsEdit.svg';
import { Button, Modal } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { NumberInput } from '../../../../CommonMethhods/CommonMethods';
import axios from 'axios';
import { toast } from 'react-toastify';
import addIcon from "../../../../asset/images/add.svg";
import OtpInput from '../../../LeadCreation/OtpInput';
import { ProgressBar } from "react-bootstrap";

const IbaBank = ({ selectedAgent }) => {
  const getRole = localStorage.getItem("IbaRole");
  const [filterModal, setFilterModal] = useState(false);
  const [agentData, setAgentData] = useState(selectedAgent);
  const [otpModal, setOtpModal] = useState(false);
  const OTP_TIME = 30;

const [timeLeft, setTimeLeft] = useState(OTP_TIME);
const [isActive, setIsActive] = useState(true);


useEffect(() => {
  let timer;

  if (isActive && timeLeft > 0) {
    timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);
  }

  if (timeLeft === 0) {
    setIsActive(false);
  }

  return () => clearInterval(timer);
}, [timeLeft, isActive]);
  

  const schema = Yup.object().shape({
    accountNumber: Yup.string()
      .matches(/^\d{12,18}$/, 'Account Number must be 12-18 digits')
      .required('Account Number is required'),
    ifscCode: Yup.string()
      .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, 'Invalid IFSC Code')
      .required('IFSC Code is required'),
    micr: Yup.string()
      .matches(/^\d{9,12}$/, 'MICR must be 9–12 digits')
      .required('MICR is required'),
    branchName: Yup.string().required('Branch Name is required'),
    branchAddress: Yup.string().required('Branch Address is required'),
  });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    setAgentData(selectedAgent);
  }, [selectedAgent]);

  const openEditModal = () => {
    setFilterModal(true);
    reset({
      accountNumber: agentData?.account_number || '',
      ifscCode: agentData?.ifsc_code || '',
      micr: agentData?.micr || '',
      branchName: agentData?.branch_name || '',
      branchAddress: agentData?.branch_address || '',
    });
  };

  const onSubmit = async (data) => {
    try {
      const payload = {
        account_number: data.accountNumber,
        ifsc_code: data.ifscCode,
        micr: data.micr,
        branch_name: data.branchName,
        branch_address: data.branchAddress,
      };
      const agentId = agentData?.id;
      if (!agentId) {
        console.error("Agent ID is missing.");
        return;
      }
      const response = await axios.put(
        `https://uat-cosmos.bajajfinservsecurities.in/iba/api/v1/admin/agents/${agentId}/bank_details`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            reserv: 0,
            Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
          },
        }
      );

      console.log('✅ API Success:', response.data);
      if (response.data.status == 0) {
        toast.success(response.data.message);
        if (response.data?.data) {
          setAgentData(response.data.data);
        }
        setFilterModal(false);
      } else {

      }

    } catch (error) {
      console.error('❌ API Error:', error);
    }
  };

  console.log(selectedAgent, "selectedAgentBank");


  return (
    <>
      <div className="personal-details-card">
        <div className="card-head">
          <div className="card-header">Bank Details</div>
          {/* <img src={detailsEdit} style={{cursor:"pointer"}} alt="detailsEdit" onClick={openEditModal} /> */}
        </div>

        <div className="detail-row">
          <span className="label">Account Number:</span>
          <span className="value">{selectedAgent?.Personal?.AccountNumber || '-'}</span>
        </div>
        <div className="detail-row">
          <span className="label">IFSC Code:</span>
          <span className="value">{selectedAgent?.Personal?.IFSCCode || '-'}</span>
        </div>
        <div className="detail-row">
          <span className="label">MICR:</span>
          <span className="value">{selectedAgent?.Personal?.MICRCode || '-'}</span>
        </div>
        <div className="detail-row">
          <span className="label">Branch Name:</span>
          <span className="value">{selectedAgent?.Personal?.BranchName || '-'}</span>
        </div>
        <div className="detail-row">
          <span className="label">Branch Address:</span>
          <span className="value">{selectedAgent?.Personal?.BranchAddress || '-'}</span>
        </div>

        {/* <div className='add-btn-iba'
          // onClick={openEditModal}
          onClick={() => setOtpModal(true)}
        >
          <img
            src={addIcon}
            alt="addDetails"
          />
          Add Bank
        </div> */}

      </div>

      {/* Modal */}
      <Modal show={filterModal} size="lg" centered className="rm-model filter-update-telecaller iba-modals">
        <Modal.Header className="mb-4 modal-header">
          <Modal.Title id="contained-modal-title-vcenter modal-title">
            <div className="iba-bank-modal">
              <span className="main-title">Add New Bank Details</span>
              <span className='faded-title'>Enter new bank details below</span>
            </div>
          </Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => setFilterModal(false)}
          >
            <span className="icon-close"></span>
          </button>
        </Modal.Header>
        <Modal.Body>

          <form onSubmit={handleSubmit(onSubmit)} className="profile-modal-content">

            <div className="profile-form-row">
              <div className="form-group">
                <label>Account Number</label>
                <input onInput={NumberInput} {...register('accountNumber')} type="text" />
                {errors.accountNumber && <p className="error">{errors.accountNumber.message}</p>}
              </div>

              <div className="form-group">
                <label>Confirm Account Number</label>
                <input onInput={NumberInput} {...register('accountNumber')} type="text" />
                {errors.accountNumber && <p className="error">{errors.accountNumber.message}</p>}
              </div>

              <div className="form-group">
                <label>IFSC Code</label>
                <input {...register('ifscCode')} type="text" />
                {errors.ifscCode && <p className="error">{errors.ifscCode.message}</p>}
              </div>
            </div>

            {/* <div className="profile-form-row">
                <div className="form-group">
                  <label>MICR:</label>
                  <input {...register('micr')} type="text" />
                  {errors.micr && <p className="error">{errors.micr.message}</p>}
                </div>

                <div className="form-group">
                  <label>Branch Name:</label>
                  <input {...register('branchName')} type="text" />
                  {errors.branchName && <p className="error">{errors.branchName.message}</p>}
                </div>
              </div>

              <div className="profile-form-row">
                <div className="form-group" style={{ width: '100%' }}>
                  <label>Branch Address:</label>
                  <textarea {...register('branchAddress')} rows="2" />
                  {errors.branchAddress && <p className="error">{errors.branchAddress.message}</p>}
                </div>
              </div> */}

            <div className='upload-wrapper'>
              <div className='title-wrapper'>
                <span className='main-upload-title'>Upload Bank Proof</span>
                <span className='faded-upload-title'>Upload Cancelled Cheque/ Passbook</span>

              </div>
              <div className='upload-btn-wrap'>
                <input
                  type="file"
                  id="aadhar"
                  accept="image/png,image/jpeg,image/jpg"
                  className="pan-form"
                // onChange={(e) => handleAddressUpload(e, 2)}
                // key={aadhar?.name || ""}
                />
                {/* {documentData["2"]?.isAvailable ? ( */}
                <label for="aadhar">Upload File</label>
              </div>
            </div>


            <div className="profile-footer-iba">
              <Button className="cancel-btn-iba" onClick={() => setFilterModal(false)}>CANCEL</Button>
              <Button type="submit" className="save-btn-iba">ADD BANK</Button>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      {/* otp modal */}

      <Modal
        show={otpModal}
        // onHide={onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="otp-modal setting-model iba-otp-modal"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="modal-header">
          {/* <Modal.Title id="contained-modal-title-vcenter modal-title">
            <div className="figure-inlac">
              <h2 className="h2-css-all">Enter OTP</h2>
            </div>
          </Modal.Title> */}
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => setOtpModal(false)}
          >
            <span className="icon-close"></span>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="inactive-modal-table otp-modal-body">
            <span className="main-title">Enter Phone Number</span>
            <div className="wrap-otp-text">
              <p className="otp-text">
                Enter phone number to receive OTP
                </p>

                <div className="phone-input-wrapper">
                  <span className="country-code">+91</span>
                  <input
                    type="text"
                    maxLength={10}
                    className="phone-input"
                    placeholder="9XXXXXXXXX"
                  />
                </div>

                <div className="otp-timer-wrapper">
                  <div className="progress-section">
                    <ProgressBar
                      now={(timeLeft / OTP_TIME) * 100}
                      className="otp-progress"
                    />
                  </div>

                  <span className="timer-text">
                    {timeLeft > 0 ? `${timeLeft} sec remaining` : "OTP Expired"}
                  </span>
                </div>

                <p className="resend-text">
                  Haven’t received OTP?
                  <span
                    className={`resend-link ${timeLeft === 0 ? "active" : "disabled"}`}
                    onClick={() => {
                      if (timeLeft === 0) {
                        setTimeLeft(OTP_TIME);
                        setIsActive(true);
                      }
                    }}
                  >
                    {" "}Resend OTP
                  </span>
                </p>
              
            </div>

            <div className="nominee-btn-wrapper">
                <button
                  type="submit"
                  className='val-btn-wrap'
                // className={`${
                //   !isOtpComplete ? "disable-btn val-btn-wrap" : "val-btn-wrap"
                // }`}
                // onClick={() => handleVerifyData()}
                // disabled={!isOtpComplete}
                >
                  GET OTP
                </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

    </>
  );
};

export default IbaBank;
